import {RequestState} from "modules/enums";
import {IStore} from "modules/types/store";
import {createSelector} from "reselect";
import {find} from "lodash";

export const getLeaderboardsStore = (store: IStore) => store.leaderboards;

export const getLeaderboard = createSelector([getLeaderboardsStore], (store) => {
	return store.ladder;
});

export const getLastLeaderboardPayload = createSelector([getLeaderboardsStore], (store) => {
	return store.lastPayload;
});

export const getIsLoadedLeaderboards = createSelector(
	[getLeaderboardsStore],
	(store) => store.requestState === RequestState.Received
);

export const getFetchedLeaderboardPages = createSelector(
	[getLeaderboardsStore],
	(store) => store.fetchedPages
);

export const getLeaderboardUserByUserId = createSelector(
	[getLeaderboard],
	(ladder) => (userId: number) => {
		return find([...ladder.ranks, ladder.user], {
			userId,
		});
	}
);

export const getProfileByUserId = createSelector(
	[getLeaderboardsStore],
	(store) => (userId: number) => {
		return store.profiles[userId];
	}
);

export const isProfileRequested = createSelector(
	[getLeaderboardsStore],
	(store) => store.profileRequestState === RequestState.Requested
);

export const isVisibleNotice = createSelector(
	[getLeaderboardsStore],
	(store) => store.isVisibleUpdateNotice
);
